export default __webpack_public_path__ + "static/media/attendees.21bb85db.svg";